import { ExternalLinkIcon } from '@chakra-ui/icons';
import { Box, Heading, Link, Text } from '@chakra-ui/react';
import { useAuthState } from 'react-firebase-hooks/auth';
import { auth } from '../../firebase';
import { generateGuid } from '../../shared/util';
import './Dashboard.css';

export default function HiringGuide() {
    const [user] = useAuthState(auth);

    const copy = {
        hiringGuide: {
            header: 'Take our Career Assessment',
            body: 'Discover which career roles fit you best!',
            buttonText: 'Take the Asssessment',
            buttonLink:
                `https://pathmatch.typeform.com/to/elmCcb` +
                `#cid=${generateGuid()}&uid=${user?.uid}`
        }
    };
    return (
        <Box className="boxContent">
            <Heading className="boxHeading" fontSize={{ base: '22px' }}>
                {copy.hiringGuide.header}
            </Heading>
            <Text mt="2" mb="2" fontSize={{ base: '14px' }} lineHeight={{ base: '24px' }}>
                {copy.hiringGuide.body}
            </Text>
            <Link href={copy.hiringGuide.buttonLink} isExternal>
                {copy.hiringGuide.buttonText}
                <ExternalLinkIcon mx="4px" />
            </Link>
        </Box>
    );
}
